import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import { useState } from "react";
import HowItWorksPanel from "../../components/howItWorksPanel/HowItWorksPanel.jsx";
import bkLogo from "../../../../images/bklogo.svg";
import foodoraLogo from "../../../../images/icons/foodora-logo-color.svg";
import mkoeLogo from "../../../../images/icons/mkoe-logo-color.svg";
import raiffeisenLogo from "../../../../images/icons/raiffeisen-logo-color.svg";
import shopifyLogo from "../../../../images/icons/shopify-logo-color.svg";
import telekomLogo from "../../../../images/icons/telekom-logo-color.svg";
import i18n from "../../../../utils/i18n";
import classes from "./commonValueProp.module.scss";

const FEATURE_CARDS = [
  {
    title: i18n.t("searchflow.feature1title"),
    description: i18n.t("searchflow.feature1desc"),
  },
  {
    title: i18n.t("searchflow.feature2title"),
    description: i18n.t("searchflow.feature2desc"),
  },
  {
    title: i18n.t("searchflow.feature3title"),
    description: i18n.t("searchflow.feature3desc"),
  },
];

const MOBILE_PARTNER_LOGOS = [
  { src: raiffeisenLogo, alt: "Raiffeisen Bank" },
  { src: telekomLogo, alt: "Telekom" },
  { src: mkoeLogo, alt: "Magyar Könyvelők Országos Egyesülete" },
];

const DESKTOP_PARTNER_LOGOS = [
  ...MOBILE_PARTNER_LOGOS,
  { src: foodoraLogo, alt: "Foodora" },
  { src: shopifyLogo, alt: "Shopify" },
];

const ContinueButton = ({ className, onClick }) => (
  <button type="button" className={className} onClick={onClick}>
    <span>{i18n.t("searchflow.ctacontinue")}</span>
    <ChevronRightIcon className={classes.ctaIcon} aria-hidden="true" />
  </button>
);

const CommonValueProp = ({ handleNext, showTopBar = false }) => {
  const [isHowItWorksOpen, setIsHowItWorksOpen] = useState(false);

  return (
    <div className={classes.root}>
      {showTopBar ? (
        <header className={classes.topBar}>
          <div className={classes.logoWrap}>
            <img src={bkLogo} alt="bookkeepie" className={classes.heroLogo} />
          </div>
          <button
            type="button"
            className={classes.howItWorksButton}
            onClick={() => setIsHowItWorksOpen(true)}
          >
            {i18n.t("searchflow.howitworksbutton")}
          </button>
        </header>
      ) : null}

      <div className={classes.scrollArea}>
        <div className={classes.layout}>
          <div className={classes.leftColumn}>
            <div className={classes.heroBox}>
              <section className={classes.hero}>
              <h1 className={classes.heroTitle}>
                {i18n.t("searchflow.herotitle")}
              </h1>

              <p className={classes.heroSubtitle}>
                {i18n.t("searchflow.herosubtitle")}
              </p>

              <div className={classes.heroBadges}>
                <span className={classes.heroBadge}>
                  <AccessTimeOutlinedIcon
                    className={classes.heroBadgeIcon}
                    aria-hidden="true"
                  />
                  {i18n.t("searchflow.heromax5min")}
                </span>
                <span className={classes.heroBadgeDivider} aria-hidden="true" />
                <span className={classes.heroBadge}>
                  <LocalOfferOutlinedIcon
                    className={`${classes.heroBadgeIcon} ${classes.heroBadgeOfferIcon}`}
                    aria-hidden="true"
                  />
                  {i18n.t("general.free")}
                </span>
              </div>

              <ContinueButton
                className={classes.ctaButton}
                onClick={handleNext}
              />
            </section>

            <section className={classes.partners} aria-label={i18n.t("header/footer.partners")}>
              <div className={classes.partnersRow}>
                <span className={classes.partnersLabel}>{i18n.t("header/footer.partners")}:</span>
                <div className={classes.partnerLogosMobile}>
                  {MOBILE_PARTNER_LOGOS.map((logo) => (
                    <img key={logo.alt} src={logo.src} alt={logo.alt} />
                  ))}
                </div>
                <div className={classes.partnerLogosDesktop}>
                  {DESKTOP_PARTNER_LOGOS.map((logo) => (
                    <img key={logo.alt} src={logo.src} alt={logo.alt} />
                  ))}
                </div>
              </div>
            </section>
            </div>
          </div>

          <div className={classes.rightColumn}>
            <section className={classes.features} aria-label={i18n.t("searchflow.advantageslabel")}>
              <h2 className={classes.featuresTitle}>
                {i18n.t("searchflow.featurestitle")}
              </h2>
              <p className={classes.featuresIntro}>
                {i18n.t("searchflow.featuresintro")}
              </p>

              <div className={classes.featureCards}>
                {FEATURE_CARDS.map((card) => (
                  <article key={card.title} className={classes.featureCard}>
                    <h3 className={classes.featureTitle}>{card.title}</h3>
                    <p className={classes.featureDescription}>
                      {card.description}
                    </p>
                  </article>
                ))}
              </div>
            </section>

            <section className={classes.bottomCta} aria-label={i18n.t("searchflow.recommendlabel")}>
              <h2 className={classes.bottomCtaTitle}>
                {i18n.t("searchflow.bottomctatitle")}
              </h2>
              <p className={classes.bottomCtaText}>
                {i18n.t("searchflow.bottomctatext")}
              </p>
              <ContinueButton
                className={classes.ctaButton}
                onClick={handleNext}
              />
            </section>
          </div>
        </div>
      </div>

      <HowItWorksPanel
        open={isHowItWorksOpen}
        onClose={() => setIsHowItWorksOpen(false)}
        onContinue={handleNext}
      />
    </div>
  );
};

export default CommonValueProp;
